export default __webpack_public_path__ + "static/media/palletizing.d5fd3986.gif";